<template>
  <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="loading.page"
  >
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">Create Addendum</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Details" />
    </a-steps>
    <div class="steps-content flex-1">
      <component
        class="flex-1"
        :is="steps[current].content"
        :ref="stepRef"
        v-bind="stepProps"
      ></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next"
          :disabled="trigger.disabledNext"
          >Next</a-button
        >
        <a-button
          v-if="current == steps.length - 1"
          :loading="loading.button"
          type="primary"
          @click="validate"
          :disabled="trigger.disabledNext"
          >{{ mode == "Edit" ? "Save Changes" : "Save" }}</a-button
        >
        <a-button v-if="current > 0" @click="prev"
          :disabled="trigger.disabledPrev"
          >Previous</a-button>
      </div>
    </template>
  </a-card>
  </a-spin>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import Informasi from "./steps/Informasi.vue";
import Detail from "./steps/Detail.vue";
import moment from "moment";
import _ from "lodash";

export default {
  name: "CreateAddendum",
  props: ["id","jenis_transaksi"],
  mixins: [GlobalMethod],
  components: {
    Informasi,
    Detail
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "Detail",
          content: "Detail",
        },
      ],
      mode: "Create",
      collectData: {},
      listPembelian: [],
      ppdtlInParent: [],
      postData: new FormData(),
      postJson: {},
      editData: {},
      projectAllsts: [],
      disabledNext: true,
      loading: {
        page: false,
        button: false
      },
      requirementData:[],
      trigger: {
        disabledPrev:false,
        disabledNext:false,
      },
      CClist: []
    };
  },
  computed: {
    ...mapGetters(["getAuth","getStandartFormatDate",]),
    initialListItem() {
      let data = [];
      let hargaTotal = 0;
      // NEW
      this.listPembelian.forEach((item) => {
        hargaTotal = item.values.jumlah * item.values.harga;
        const values = item.values;
        data = [...data, { hargaTotal: hargaTotal, 
                           path: item.values.path,
                           id_anggaran: item.values.id_anggaran, values }];
      });


      return data;
    },
    stepProps: function() {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            parentListPurchasing: this.collectData.listPurchasing,
            data: this.collectData.informasi,
            mode: this.mode,
            id: this.id,
            jenis_transaksi: this.jenis_transaksi,
            requirementData: this.requirementData,
            CClist: this.CClist
          };
        } else if (this.steps[this.current].content === "Detail") {
          return {
            ppdtl: this.ppdtlInParent,
            data: this.collectData.informasi,
            parentListPurchasing: this.collectData.listPurchasing,
            mode: this.mode,
          };
        }
      } else if (this.mode === "Create") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            parentListPurchasing: this.collectData.listPurchasing,
            data: this.collectData.informasi,
            mode: this.mode,
            id: this.id,
            jenis_transaksi: this.jenis_transaksi,
            requirementData: this.requirementData,
            CClist: this.CClist
          };
        } else if (this.steps[this.current].content === "Detail") {
          return {
            ppdtl: this.ppdtlInParent,
            data: this.collectData.informasi,
            parentListPurchasing: this.collectData.listPurchasing,
            mode: this.mode,
          };
        }
      }
      return true;
    },
    stepRef: function() {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "Detail") {
        return "refDetail";
      }
      return true;
    },
  },
  created() {
    // if (this.id) {
    //   this.mode = "Edit";
    // }
  },
  methods: {
    ...mapActions(["FETCH_ALLOCATION", "FETCH_USEDFOR"]),
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
        //this.resetvalueppdtl();
      } else if (this.steps[this.current].content === "Detail") {
        this.$refs.refDetail.handleRef();
      }
    },
    prev() {
      if(this.steps[this.current].content === "Detail")
        this.$refs.refDetail.handleRef();
      this.current--;
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        this.collectData.informasi = value.informasi;
        this.current++;
      }else if(this.steps[this.current].content === "Detail"){
         this.collectData.listPurchasing = value.value;
         this.collectData.grandtotal = value.grandtotal;
      }
    },
    validate() {
      this.$refs.refDetail.handleRef();
      if(this.collectData.grandtotal<=0){
        this.displayMessageValue(
          "error-other","Grand total must be greater than 0!"
        );
        return;
      }else if(this.collectData.listPurchasing && this.collectData.listPurchasing.length<=0){
        this.displayMessageValue(
          "error-other","Purchase List Can't be Empty!"
        );
        return;
      }else{
        let valid = true;
        let str = "";
        for (let i = 0; i < this.ppdtlInParent.length; i++) {
          if(this.ppdtlInParent[i].saldo<0){
            valid=false;
            str = this.ppdtlInParent[i].kode_anggaran+" - "+ this.ppdtlInParent[i].nama_barang;
          }
        }
        if (valid){
          this.subMitValue();
        }else{
          this.displayMessageValue(
          "error-other","PP details '"+str+"' is minus, please make sure there is no minus value!"
        );
        }
      }
    },

    async subMitValue(){
      let postData = new FormData();

      if(this.mode=="Edit")
        postData.append("id_adendum", this.id);

      postData.append("tlc", this.getAuth.username);
      postData.append("id_invoice_ap_ad", this.collectData.informasi.id_invoice_ap_ad);
      postData.append("date_of_addendum", moment(this.collectData.informasi.date_of_addendum).format(this.getStandartFormatDate));
      postData.append("description", this.collectData.informasi.description);
      postData.append("note", this.collectData.informasi.note);
      postData.append("currency_to", this.collectData.informasi.currency_to);
      postData.append("rate", this.collectData.informasi.rate);
      postData.append("file_document", this.collectData.informasi.fileList[0]);
      // postData.append("jenis_transaksi",this.collectData.informasi.jns_transaksi);
      // postData.append("no_po_wo",this.jenis_transaksi ? this.collectData.informasi.no_po_wo[0].id_transaksi :
      //   this.collectData.informasi.no_po_wo.id_transaksi);
      // postData.append("id_supplier",this.collectData.informasi.id_supplier);
      // postData.append("currency_from",this.collectData.informasi.currency_from);
      // postData.append("account_bank",this.collectData.informasi.account_bank);
      // postData.append("no_tracking",this.collectData.informasi.no_tracking);
      // postData.append("no_invoice",this.collectData.informasi.no_invoice);
      // postData.append("due_date",moment(this.collectData.informasi.dueDate).format(this.getStandartFormatDate));
      // postData.append("date_invoice",moment(this.collectData.informasi.date_invoice).format(this.getStandartFormatDate));
      if(this.collectData.informasi.pib)
        postData.append("pib", this.collectData.informasi.pib?'1':'0');

      this.collectData.listPurchasing.forEach((data, index) => {
        postData.append(`is_tax[${index}]`, data.is_tax);
        postData.append(`pp_detail[${index}]`, data.id_pp_dtl);
        postData.append(`id_invoice_ap_ad_dtl[${index}]`, data.id_invoice_ap_ad_dtl);
        postData.append(`item_name[${index}]`, data.item_name);
        postData.append(`quantity[${index}]`, data.quantity);
        postData.append(`value[${index}]`, data.value);
        postData.append(`option[${index}]`, "nominal");
        postData.append(`percentage[${index}]`, "");
        postData.append(`tax_type[${index}]`, data.tax_type ? data.tax_type : undefined);
        if(data.file_document_tax.length>0)
          postData.append(`file_document_tax[${index}]`, data.file_document_tax && data.file_document_tax.length>0 ? data.file_document_tax[0] : null);
      });

      Event.$emit("addendumOnLoadingPage", true);
      await axios({
        method: "post",
        url: this.$serviceUrl + (this.mode=="Create" ? "addendum/submit" : "addendum/edit"),
        data: postData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        this.displayMessage("success-save");
        this.$router.push({ name: "account-pay-index" });
        this.loading = false
      })
      .catch((err) => {
        Event.$emit("addendumOffLoadingPage", true);
        let responses = Object.assign({}, err.response.data);
        this.displayMessageValue("error-other", responses.message);
      });
    },
    updateAddendumPPdtl(val){
      this.ppdtlInParent = val;
    },
    setLoadingPageOn(){
      this.loading.page = true;
    },
    setLoadingPageOff(){
      this.loading.page = false;
    },
    async getRequrementData(id){
      Event.$emit("addendumOnLoadingPage", true);
       await this.asyncAxiosGet(
            "addendum/create_adendum",
            this.getAuth,
            { 
              id_invoice_ap_ad: id
            }
        ).then((response) => {
            this.collectData.informasi = {
              account_bank_number: response.account_bank_number,
              bank_name: response.bank_name,
              currency_from: response.currency_from,
              date_of_invoice: response.date_of_invoice,
              due_date: response.due_date,
              id_invoice_ap_ad: response.id_invoice_ap_ad,
              kurs: response.kurs,
              no_invoice_ap_ad: response.no_invoice_ap_ad,
              no_invoice: response.no_invoice,
              no_tracking: response.no_tracking,
              supplier: response.supplier,
              description: response.description,
              note: response.note,
              pib: response.pib=='1' ? true : false,
              id_user_cc: response.id_user_cc,
          }
          this.collectData.listPurchasing = response.dtl_adendum;
          this.CClist = response.user_cc
          for (let index = 0; index < this.collectData.listPurchasing.length; index++) {
            // this.collectData.listPurchasing[index].quantity = null;
            this.collectData.listPurchasing[index].total_values = 0;
            this.collectData.listPurchasing[index].value = 0;
            this.collectData.listPurchasing[index].values = 0;
          }
          this.requirementData = response;
          this.ppdtlInParent = response.dtl_invoice;
            Event.$emit("addendumOffLoadingPage", true);
        }).catch((err) => {
            Event.$emit("addendumOffLoadingPage", true);
            console.log(err);
        });
    },
    async getTransaction(id){
      Event.$emit("addendumOnLoadingPage", true);
       await this.asyncAxiosGet(
            "addendum/edit",
            this.getAuth,
            { 
              id_adendum: id
            }
       ).then((response) => {

        this.collectData.informasi = {
          account_bank_number: response.account_bank_number,
          bank_name: response.bank_name,
          currency_from: response.currency_from,
          date_of_invoice: response.date_of_invoice,
          due_date: response.due_date,
          id_invoice_ap_ad: response.id_invoice,
          kurs: response.kurs,
          no_invoice_ap_ad: response.no_invoice_ap_ad,
          no_invoice: response.no_invoice,
          no_tracking: response.no_tracking,
          supplier: response.supplier,
          description: response.description,
          note: response.note,
          pib: response.ispib=='1'?true:false
        }
        this.collectData.listPurchasing = response.dtl_adendum
        this.requirementData = response;
        this.ppdtlInParent = response.dtl_invoice;
        
            // this.requirementData = {
            //   pp_dtl: response.pp_dtl,
            //   data_po_wo: response.data_po_wo,
            //   currency: response.currency,
            // };
            // this.ppdtlInParent = response.pp_dtl;
            // this.collectData = {
            //   informasi: response.header[0],
            //   listPurchasing: response.dtl,
            // }
            // this.no = _.filter(response.data_po_wo,(el) => el.id_transaksi==response.header[0].id_transaksi);

            let typefile = this.fileTypeFromUrl(response.document_name);
            var file = this.dataURLtoFile(typefile+response.document_file, response.document_name);
            file.uid= 'vc-upload-1-1';
            file.status= 'done';
            file.exist= true;
            file.url= this.$serviceUrl+response.document_path;
            this.collectData.informasi['fileList']=[];
            this.collectData.informasi.fileList.push(file);

            let file2 = null;
            let typefile2 = null;
            for (let index = 0; index < this.collectData.listPurchasing.length; index++) {
              if(this.collectData.listPurchasing[index].file_document_tax){
                typefile2 = this.fileTypeFromUrl(this.collectData.listPurchasing[index].file_doc_tax);
                file2 = this.dataURLtoFile(typefile2+
                  this.collectData.listPurchasing[index].file_document_tax, this.collectData.listPurchasing[index].file_doc_tax);
                file2.uid= 'vc-upload-1-1';
                file2.status= 'done';
                file2.exist= true;
                file2.url= this.$serviceUrl+this.collectData.listPurchasing[index].document_path;
                this.collectData.listPurchasing[index]['file_document_tax']=[];
                this.collectData.listPurchasing[index].file_document_tax.push(file2);
                this.collectData.listPurchasing[index].tax_type = this.collectData.listPurchasing[index].tax_type=="undefined" ? 
                  undefined : this.collectData.listPurchasing[index].tax_type;
              }else{
                this.collectData.listPurchasing[index]['file_document_tax']=[];
              }
            }

            Event.$emit("addendumOffLoadingPage", true);
        }).catch((err) => {
            Event.$emit("addendumOffLoadingPage", true);
            console.log(err);
        });
    },
    addendumGenAddRequirement(val){
      console.log(val)
      this.requirementData = val
    },
    addendumSetDisabledButton(val){
        this.trigger.disabledPrev = val.disabledPrev;
        this.trigger.disabledNext = val.disabledNext;
    },
    // resetvalueppdtl(){
    //   for (let index = 0; index < this.ppdtlInParent.length; index++) {
    //     this.ppdtlInParent[index].saldo = this.ppdtlInParent[index].saldo_ori;
    //   }
    // }
  },
  mounted() {
    //Event.$on("save", this.subMitValue);
    Event.$on("addendumEmitChild", this.valueFromChild);
    Event.$on("updateAddendumPPdtl", this.updateAddendumPPdtl);
    Event.$on("addendumOnLoadingPage", this.setLoadingPageOn);
    Event.$on("addendumOffLoadingPage", this.setLoadingPageOff);
    Event.$on("addendumGenAddRequirement", this.addendumGenAddRequirement);
    Event.$on("addendumSetDisabledButton", this.addendumSetDisabledButton);

    if(this.$route.meta.process=="create"){
      this.mode="Create";
     if (this.jenis_transaksi){
        this.getRequrementData (this.id,this.jenis_transaksi);
     }
    }else{
      this.mode="Edit";
      this.getTransaction(this.id);
    }
  },
  beforeDestroy() {
    Event.$off("addendumEmitChild", this.valueFromChild);
    Event.$off("updateAddendumPPdtl", this.updateAddendumPPdtl);
    Event.$off("addendumOnLoadingPage", this.setLoadingPageOn);
    Event.$off("addendumOffLoadingPage", this.setLoadingPageOff);
    Event.$off("addendumGenAddRequirement", this.addendumGenAddRequirement);
    Event.$off("addendumSetDisabledButton", this.addendumSetDisabledButton);
  },
};
</script>

<style></style>
